<template>
    <div class="ddc-mainform">
        <span style="display: none">{{ runningEnv }}</span>
        <!-- <div class="dcs-badge-topleft">
            <img src="../assets/Pricing3monFree.gif" />
        </div> -->
        <div class="dcs-opening-msg">
            Setting up your software account is easy!
            <br />
            Simply choose your plan, and complete the fields below.
        </div>
        <planpick></planpick>
        <div style="margin-top: 20px; min-height: 340px">
            <div class="container" v-if="viewPage == 1">
                <div class="row">
                    <div class="col-md-3" />
                    <div class="col-md-3">
                        <div class="ddc-label-cell">Contact Information</div>
                        <div class="ddc-validation-container" :class="{ fieldHasError: isFormSubmitted && validateFirstName }">
                            <input type="text" v-model="firstName" class="form-control" placeholder="first name" tabindex="11" />
                        </div>
                        <div class="ddc-validation-container" :class="{ fieldHasError: isFormSubmitted && validateLastName }">
                            <input type="text" v-model="lastName" class="form-control" placeholder="last name" tabindex="12" />
                        </div>
                        <div class="ddc-validation-container" :class="{ fieldHasError: isFormSubmitted && validateCompany }">
                            <input type="text" v-model="company" class="form-control" placeholder="company" tabindex="13" />
                        </div>
                        <div class="dcs-fixbox">
                            <span v-if="emailIsVerified" class="dcs-inline-reset" title="Reset email" @click="do_email_reset_askuser">↺</span>
                            <div class="ddc-validation-container" :class="{ fieldHasError: isFormSubmitted && validateEmail }">
                                <input type="text" v-model="email" class="form-control" placeholder="email address" :disabled="emailIsVerified" tabindex="14" />
                            </div>
                        </div>
                        <div class="dcs-align-right">
                            <button v-if="!emailIsValidatedAndAvailable" :disabled="emailIsVerified || emailValidationLock" class="btn-link ddc-btn-validate" @click="do_email_validate" tabindex="15">
                                Validate Email
                            </button>
                            <div>
                                <span v-if="emailIsValidatedAndAvailable" class="dcs-email-validated">
                                    Email Validated
                                    <span class="dcs-child2-bigger">✓</span>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="ddc-label-cell">Billing Address</div>
                        <div class="ddc-validation-container" :class="{ fieldHasError: isFormSubmitted && validateAddr1 }">
                            <input type="text" v-model="addr1" class="form-control" placeholder="address" tabindex="21" />
                        </div>
                        <div class="ddc-validation-container">
                            <input type="text" v-model="addr2" class="form-control" placeholder="(optional line 2)" tabindex="22" />
                        </div>
                        <div class="ddc-validation-container" :class="{ fieldHasError: isFormSubmitted && validateCity }">
                            <input type="text" v-model="city" class="form-control" placeholder="city" tabindex="23" />
                        </div>
                        <div class="ddc-validation-container" :class="{ fieldHasError: isFormSubmitted && validateCountry }">
                            <v-select class="ddc-select" :value="countryWidgetVal" :on-change="countryChanged" label="label" :options="countryData" placeholder="country" :tabindex="24"></v-select>
                        </div>
                        <div class="ddc-validation-container" :class="{ fieldHasError: isFormSubmitted && validateProv }">
                            <v-select
                                class="ddc-select"
                                :value="provWidgetVal"
                                :noDrop="provModel.length == 0"
                                :on-change="provChanged"
                                label="label"
                                :options="provModel"
                                placeholder="province / state"
                                :tabindex="25"
                            ></v-select>
                        </div>
                        <div class="ddc-validation-container" :class="{ fieldHasError: isFormSubmitted && validatePostal }">
                            <input type="text" v-model="postal" class="form-control" placeholder="postal code / zip" tabindex="26" />
                        </div>
                        <div style="text-align: right">
                            <button class="btn-link ddc-btn-validate" @click="clearForm">Clear Form</button>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <validate-warning :warningActive="isFormSubmitted" :validateFnc="validateFirstName" />
                        <validate-warning :warningActive="isFormSubmitted" :validateFnc="validateLastName" />
                        <validate-warning :warningActive="isFormSubmitted" :validateFnc="validateCompany" />
                        <validate-warning :warningActive="isFormSubmitted" :validateFnc="validateEmail" />
                        <validate-warning :warningActive="isFormSubmitted" :validateFnc="validateAddr1" />
                        <validate-warning :warningActive="isFormSubmitted" :validateFnc="validateCity" />
                        <validate-warning :warningActive="isFormSubmitted" :validateFnc="validateCountry" />
                        <validate-warning :warningActive="isFormSubmitted" :validateFnc="validateProv" />
                        <validate-warning :warningActive="isFormSubmitted" :validateFnc="validatePostal" />
                    </div>
                </div>
            </div>
            <div v-if="viewPage == 2">
                <div class="row">
                    <div class="col-md-4" />
                    <div class="col-md-4">
                        <div class="ddc-summary-box">
                            <table>
                                <tr>
                                    <td colspan="2" class="ddc-summary-title">Information Summary</td>
                                </tr>
                                <tr>
                                    <td class="ddc-summary-label">Name:</td>
                                    <td class="ddc-summary-value">{{ firstName }} {{ lastName }}</td>
                                </tr>
                                <tr>
                                    <td class="ddc-summary-label">Company:</td>
                                    <td class="ddc-summary-value">{{ company }}</td>
                                </tr>
                                <tr>
                                    <td class="ddc-summary-label">Email:</td>
                                    <td class="ddc-summary-value">{{ email }}</td>
                                </tr>
                                <tr>
                                    <td class="ddc-summary-label">Address:</td>
                                    <td class="ddc-summary-value">
                                        <div>{{ addr1 }}</div>
                                        <div>{{ addr2 }}</div>
                                        <div>{{ city }}</div>
                                        <div v-if="provWidgetVal">{{ provWidgetVal.label }}</div>
                                        <div v-if="countryWidgetVal">{{ countryWidgetVal.label }}</div>
                                        <div>{{ postal }}</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="ddc-summary-label">Plan:</td>
                                    <td class="ddc-summary-value">{{ curPlanData.name }}</td>
                                </tr>
                            </table>
                            <table>
                                <tr>
                                    <td class="ddc-summary-label">{{ cFreqDesc }} Cost:</td>
                                    <td class="ddc-summary-value">
                                        <div class="dds-estimated-cost" style="background-color: unset">
                                            <label>USD</label>
                                            <span class="dcs-final-cost">{{ formatPrice(discountedCost) }}</span>
                                        </div>
                                        <span v-if="hasDiscount" class="ddc-small-submessage">for first year</span>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div class="col-md-4" />
                </div>
            </div>
            <div v-if="viewPage == 3">
                <div style="height: 30px" />
                <cardinfo></cardinfo>
            </div>
        </div>
        <div class="container dcs-footer-grid">
            <div class="row">
                <div class="col-md-3">
                    <div class="ddc-label-cell" v-if="freqVisible">Billing Frequency:</div>
                    <div class="dds-billfreq-input" v-if="freqVisible">
                        <input type="radio" id="diBillFreq1" value="A" v-model="billFreq" />
                        <label for="diBillFreq1">Annual</label>
                        <br />
                        <input type="radio" id="diBillFreq2" value="M" v-model="billFreq" />
                        <label for="diBillFreq2">Monthly</label>
                    </div>
                    <div class="dcs-lcount-widget" v-if="lcountVisible">
                        <label>#logins</label>
                        <input type="number" min="2" max="10" step="1" class="dcs-lcount-spinner" v-model="loginCount" />
                        <button v-if="mobile" class="dcs-mini-button-plus" @click="loginCount++">+</button>
                        <button v-if="mobile" class="dcs-mini-button-minus" @click="loginCount--">-</button>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="dds-cost-calc-holder">
                        <div class="ddc-label-cell">{{ cFreqDesc }} Cost:</div>
                        <div class="dds-estimated-cost">
                            <label>USD</label>
                            <span class="dcs-final-cost">{{ formatPrice(summaryCost) }}</span>
                        </div>
                        <div v-if="!hasDiscount" class="dds-free-trial-msg" v-bind:class="creditCardClassEnh()">
                            Includes 14 day
                            <span class="dds-free-word">Free</span>
                            Trial!
                        </div>
                    </div>
                    <span v-if="hasDiscount">
                        <div style="height: 24px" />
                        <div style="position: relative">
                            <div class="ddc-saving-premable ddc-label-cell">Your price today with discount!</div>
                            <div class="dds-cost-calc-holder">
                                <div style="position: relative; display: inline-flex; flex-direction: column; align-items: flex-end">
                                    <div class="dds-estimated-cost">
                                        <label>USD</label>
                                        <span class="dcs-final-cost">{{ formatPrice(discountedCost) }}</span>
                                    </div>
                                    <div class="ddc-small-submessage">for first year</div>
                                </div>
                            </div>
                        </div>
                        <div class="dds-cost-calc-holder">
                            <div class="dds-free-trial-msg" v-bind:class="creditCardClassEnh()">
                                Includes 14 day
                                <span class="dds-free-word">Free</span>
                                Trial!
                            </div>
                        </div>
                    </span>
                    <!-- <YourPrice v-if="hasDiscount" :price="formatPrice(discountedCost)" style="margin-top:16px;"/>                     -->
                </div>
                <div class="col-md-3" style="text-align: left" v-if="couponsExist">
                    <div v-if="freqVisible">
                        <div class="ddc-label-cell">Coupon code:</div>
                        <div style="position: relative; display: inline-block">
                            <input v-if="!signupFormData.couponCode" ref="refCouponInput" type="text" v-model="txtCouponCode" class="form-control" style="width: 10em; text-transform: uppercase" />
                            <input
                                v-if="!!signupFormData.couponCode"
                                ref="refCouponInput"
                                type="text"
                                :value="signupFormData.couponCode"
                                :disabled="true"
                                class="form-control"
                                style="width: 10em; text-transform: uppercase"
                            />
                            <div v-if="signupFormData.couponCode || txtCouponCode" class="dcs-mini-clear-btn" @click="clearCouponCode">X</div>
                        </div>
                        <div style="margin: 4px">
                            <button v-if="!signupFormData.couponCode" class="btn-link ddc-btn-validate" @click="applyCouponCode">Apply</button>
                            <div v-if="signupFormData.couponCode" class="dcs-coupon-applied">Applied</div>
                        </div>
                        <validate-warning :warningActive="!!couponErrorMsg" :validateFnc="couponErrorMsg" style="display: inline-block" />
                    </div>
                </div>
                <div class="col-md-3 dds-action-btns">
                    <button v-if="viewPage > 1" class="btn btn-success" @click="do_page(-1)">Back...</button>
                    <div class="dds-btn-absense" v-if="viewPage == 1" />
                    <button class="btn btn-success" @click="do_page(1)">Next...</button>
                    <!-- <button class="btn btn-success" @click="doModalInfo('This is the message body for the dialogue box.')">Foo...</button>  -->
                </div>
            </div>
        </div>
        <modal v-if="showModalError" class="dds-modal-error" @close="closeModalError">
            <div slot="body" v-html="modalErrorBody"></div>
            <h2 slot="header"></h2>
        </modal>
        <modal v-if="showModalInfo" class="dds-modal-info" @close="closeModalInfo">
            <div slot="body" v-html="modalInfoBody"></div>
            <h2 slot="header" v-html="modalInfoTitle"></h2>
        </modal>
        <modal v-if="showResendCode" class="dds-modal-info">
            <h3 slot="header">Email Exists</h3>
            <div slot="body" v-html="modelResendBody"></div>
            <div slot="footer">
                <button class="modal-button" @click="showResendCode = false">Cancel</button>
                <button class="modal-default-button" @click="processResendCode">OK</button>
            </div>
        </modal>
        <modal v-if="showEmailResetAsk" class="dds-modal-info">
            <h3 slot="header">Reset email field</h3>
            <div slot="body" v-html="modelEmailReset"></div>
            <div slot="footer">
                <button class="modal-button" @click="showEmailResetAsk = false">Cancel</button>
                <button class="modal-default-button" @click="do_email_reset">OK</button>
            </div>
        </modal>
        <modal v-if="showConfCode" class="dds-modal-confcode">
            <h3 slot="header">Email Validation</h3>
            <div slot="body">
                An email has been sent to you containing a verification code. If you don&apos;t received it within a couple of minutes, please check your spam folder.
                <br />
                <br />
                Enter the verification code here:
                <br />
                <input type="text" v-model="txtConfCode" class="form-control" />
            </div>
            <div slot="footer">
                <button class="modal-button" @click="showConfCode = false">Cancel</button>
                <button class="modal-default-button" @click="processConfCode">OK</button>
            </div>
        </modal>
        <modal v-if="showBusy" class="dcs-busy" @close="showBusy = false">
            <div slot="body">
                <div>Processing. Please wait...</div>
                <div class="dcs-wait-icon">
                    <img src="../assets/gears.gif" />
                </div>
            </div>
            <div slot="footer"></div>
        </modal>
    </div>
</template>


<script>
// import { getConfig } from '../envconfig';
import { messagebus } from "../main";
import planpick from "./PlanPick";
import vSelect from "vue-select";
import modal from "./Modal";
import validateWarning from "./ValidateWarning.vue";
import cardinfo from "./CardInfo.vue";
import YourPrice from "./YourPrice";

import { validations as otherValidations, submitSignup, creditCardErrorMessage, devlog, fieldRequiredProblem, getCognitoSession } from "./Signup-lib.js";
import { countries as countryData, territories as provData, config, isCouponValid, doesCouponCodeExist } from "./Signup-dat.js";
// console.log("Hello from Signup.  Country Data = " + countryData);
export default {
    name: "signup",
    components: { vSelect, planpick, modal, validateWarning, cardinfo, YourPrice },
    data() {
        return {
            countryData,
            showModalError: false,
            showModalInfo: false,
            showResendCode: false,
            showConfCode: false,
            showBusy: false,
            showEmailResetAsk: false,
            modalErrorBody: "",
            modalInfoBody: "",
            modalInfoRedirect: "",
            modalInfoTitle: "",
            modelResendBody: config.messages.alreadyEnteredNotValidated,
            modelEmailReset: config.messages.emailResetQuestion,
            txtConfCode: "",
            txtCouponCode: "",
            couponErrorMsg: "",
            runningEnv: process.env.NODE_ENV,
            mobile: window.innerWidth <= 800
        };
    },
    created() {
        addEventListener("resize", () => {
            this.mobile = innerWidth <= 800;
        });
        messagebus.$on("confDialog", () => this.doConfDialog());
        messagebus.$on("doModalError", msg => this.doModalError(msg));
        messagebus.$on("doResendDialog", () => this.doResendDialog());
        messagebus.$on("hideConfDialog", () => this.hideConfDialog());
        messagebus.$on("doShowBusy", () => this.do_show_busy());
        messagebus.$on("doModalInfo", ({ msg, redirect, title }) => this.doModalInfo(msg, redirect, title));
    },
    methods: {
        countryChanged(val) {
            this.$store.dispatch("UPDATE_COUNTRY", val);
        },
        provChanged(val) {
            devlog(" Prov Change Handler with: " + JSON.stringify(val));
            this.$store.commit("SIGNUP_FORM", { province: val });
        },
        do_page(incr) {
            let viewPage = this.$store.state.signupFormData.viewPage;
            let nextPage = viewPage + incr;
            if (viewPage === 1) {
                // "Post-Page" checks for Page#1
                this.$store.commit("SIGNUP_FORM_SUBMIT_COUNT", 1);
                let errCount = 0;
                Object.keys(otherValidations).forEach(funcName => {
                    let vRslt = otherValidations[funcName].apply(this); // console.log("test : " + vRslt);
                    if (vRslt) {
                        errCount++;
                    }
                });
                devlog("Check Page1 errors.  Now its: " + errCount);
                if (errCount > 0) {
                    return;
                }
            }

            // Skip Page#3 if no credit card is needed
            if (nextPage === 3 && !this.requiresCreditCard) {
                nextPage = nextPage + incr;
            }
            if (nextPage === 3) {
                // "Pre-Page" checks for Page#3
                let cardDetail = this.$store.state.signupFormData.cardDetail;
                let cardAddendum = {};
                if (!cardDetail.name) {
                    cardAddendum.name = ((this.firstName || "") + " " + (this.lastName || "")).trim();
                }
                if (!cardDetail.expiry) {
                    cardAddendum.expiry = "";
                }
                this.$store.commit("CREDIT_CARD_DETAIL", cardAddendum);
            }
            if (viewPage === 3) {
                // "Post-Page" checks for Page#3
                if (nextPage === 2) {
                    // When going backwards, skip Page#2
                    nextPage = 1;
                }
            }
            if (nextPage === 4) {
                // "Pre-Page" checks for Page#4
                // If there's any problem with the Credit Catd, set the flag to show
                //  the CardError warning, and exit this processing
                // NOTE: Credit Card validations used to be "post-page-3" but they must be "pre-page-4" so
                //    that user can navigate back to page#1 from page#2 with invalid data.
                //  AND!!  Only enforce this if we are in a plan that requires Credit Card
                if (this.requiresCreditCard && creditCardErrorMessage(this.$store.state.signupFormData.cardDetail)) {
                    this.$store.commit("CARD_ERROR_STATE", true);
                    return;
                }
                // console.log(`There were no problems with Credit Card`);
                // Sample calls to provisioning API
                devlog("Test call to provisioning API ");
                submitSignup({ commit: this.$store.commit }, this.$store.state, this);
                return;
            }
            this.$store.commit("SIGNUP_FORM_PAGE", nextPage);
        },
        do_show_busy() {
            this.showBusy = true;
        },
        do_email_validate() {
            this.$store.dispatch("VALIDATE_EMAIL_BEGIN", this);
        },
        temp_email_validate() {
            // FOO
            console.log(`This is temp_email_validate ${this.email}`);
            getCognitoSession({ email: this.email })
                .then(({ session }) => {
                    console.log(` Back from getCogSession `);
                    const idToken = session.getIdToken().getJwtToken();
                    console.log(`    getCogSession ${idToken} `);
                    return this.$http.get(`/api/misc/emailAvailable`, {
                        headers: {
                            Authorization: idToken
                        }
                    });
                })
                .then(result => {
                    console.log("  emailAvail received response: " + JSON.stringify(result));
                });
        },
        do_email_reset_askuser() {
            this.showEmailResetAsk = true;
        },
        do_email_reset() {
            this.showEmailResetAsk = false;
            this.$store.commit("COGNITO_PROFILE", {
                email_verified: undefined,
                sub: undefined,
                emailIsAvailable: undefined
            });
            this.$store.commit("SIGNUP_FORM", { email: undefined });
        },
        doModalError(msg) {
            this.showBusy = false;
            this.modalErrorBody = msg;
            this.showModalError = true;
        },
        closeModalError() {
            devlog("We are now closing modal error.");
            this.showModalError = false;
        },
        doModalInfo(msg, redirect, title) {
            this.showBusy = false;
            this.modalInfoTitle = title || "";
            this.modalInfoBody = msg;
            this.showModalInfo = true;
            this.modalInfoRedirect = redirect;
        },
        closeModalInfo() {
            devlog("We are now closing modal info.  " + (this.modalInfoRedirect ? "Going to Redirect to " + this.modalInfoRedirect : ""));
            this.showModalInfo = false;
            if (this.modalInfoRedirect) {
                window.location.replace(this.modalInfoRedirect);
            }
        },
        doConfDialog() {
            this.showBusy = false;
            this.txtConfCode = "";
            this.showConfCode = true;
        },
        processConfCode() {
            devlog("Processing the ConfCode thing with " + this.txtConfCode);
            if (!this.txtConfCode) {
                this.doModalError("You must enter the verification code");
                return;
            }
            this.$store.dispatch("PROCESS_CONF_CODE", this.txtConfCode);
        },
        hideConfDialog() {
            this.txtConfCode = "";
            this.showConfCode = false;
        },
        doResendDialog() {
            this.showResendCode = true;
        },
        processResendCode() {
            devlog("Processing resend ConfCode thing");
            this.showResendCode = false;
            this.$store.dispatch("RESEND_CONF_CODE", this);
        },
        formatPrice(value) {
            let val = (value / 1).toFixed(2);
            return "$" + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        creditCardClassEnh() {
            if (this.requiresCreditCard) {
                return "requires-credit-card";
            }
            return null;
        },
        applyCouponCode() {
            this.txtCouponCode = (this.txtCouponCode || "").toUpperCase().trim();
            if (!this.txtCouponCode) {
                return;
            }
            if (isCouponValid(this.txtCouponCode, this.signupFormData.planClass, this.signupFormData.billFreq)) {
                this.$store.commit("SIGNUP_FORM", { couponCode: this.txtCouponCode });
                return;
            }
            if (doesCouponCodeExist(this.txtCouponCode)) {
                this.couponErrorMsg = "Valid for Professional Annual plans only";
            } else {
                this.couponErrorMsg = "Invalid Coupon Code";
            }
            setTimeout(() => {
                this.couponErrorMsg = "";
            }, 2500);
            this.$refs.refCouponInput.focus();
        },
        clearCouponCode() {
            this.txtCouponCode = "";
            this.$store.commit("SIGNUP_FORM", { couponCode: "" });
        },
        clearForm() {
            this.$store.dispatch("clearForm");
        }
    },
    computed: {
        ...otherValidations,
        signupFormData() {
            return this.$store.state.signupFormData;
        },
        firstName: {
            get() {
                return this.$store.state.signupFormData.firstName;
            },
            set(value) {
                this.$store.commit("SIGNUP_FORM", { firstName: value });
            }
        },
        lastName: {
            get() {
                return this.$store.state.signupFormData.lastName;
            },
            set(value) {
                this.$store.commit("SIGNUP_FORM", { lastName: value });
            }
        },
        email: {
            get() {
                return this.$store.state.signupFormData.email;
            },
            set(value) {
                this.$store.commit("SIGNUP_FORM", { email: value });
            }
        },
        company: {
            get() {
                return this.$store.state.signupFormData.company;
            },
            set(value) {
                this.$store.commit("SIGNUP_FORM", { company: value });
            }
        },
        addr1: {
            get() {
                return this.$store.state.signupFormData.addr1;
            },
            set(value) {
                this.$store.commit("SIGNUP_FORM", { addr1: value });
            }
        },
        addr2: {
            get() {
                return this.$store.state.signupFormData.addr2;
            },
            set(value) {
                this.$store.commit("SIGNUP_FORM", { addr2: value });
            }
        },
        city: {
            get() {
                return this.$store.state.signupFormData.city;
            },
            set(value) {
                this.$store.commit("SIGNUP_FORM", { city: value });
            }
        },
        postal: {
            get() {
                return this.$store.state.signupFormData.postal;
            },
            set(value) {
                this.$store.commit("SIGNUP_FORM", { postal: value });
            }
        },
        billFreq: {
            get() {
                return this.$store.state.signupFormData.billFreq;
            },
            set(value) {
                this.$store.dispatch("changeBillFreq", value);
            }
        },
        loginCount: {
            get() {
                return this.$store.state.signupFormData.loginCount;
            },
            set(value) {
                let fixVal = Math.round(value);
                let curPlanData = this.curPlanData;
                let minUsers = curPlanData.minUsers || 1;
                let maxUsers = curPlanData.maxUsers || 1;
                fixVal = fixVal > maxUsers ? maxUsers : fixVal < minUsers ? minUsers : fixVal;
                this.$store.commit("SIGNUP_FORM", { loginCount: fixVal });
            }
        },
        countryWidgetVal: function() {
            return this.$store.state.signupFormData.country;
        },
        provWidgetVal: function() {
            return this.$store.state.signupFormData.province;
        },
        provModel: function() {
            let curCountry = this.$store.state.signupFormData.country;
            if (!curCountry) {
                return [];
            }
            let filtered = provData.filter(el => el["country-id"] === curCountry.key);
            // devlog(" Calcd a derived promModel of " + JSON.stringify(filtered));
            return filtered;
        },
        curPlanData: function() {
            let planClass = this.$store.state.signupFormData.planClass;
            return config.planData[String(planClass)];
        },
        requiresCreditCard() {
            // let cp = this.curPlanData;
            // console.log("Logging in cc func :" + JSON.stringify(cp));
            return !!this.curPlanData.requiresCreditCard;
        },
        freqVisible() {
            return this.requiresCreditCard;
        },
        lcountVisible: function() {
            return (this.curPlanData.maxUsers || 1) > 1;
        },
        emailIsVerified: function() {
            return this.$store.getters.emailIsVerified;
        },
        emailIsValidatedAndAvailable: function() {
            return this.$store.getters.emailIsValidatedAndAvailable;
        },
        // **Doesn't look like getting used any more
        // monthlyCost: function() {
        //     let curPlanData = this.curPlanData;
        //     let billFreq = this.$store.state.signupFormData.billFreq;
        //     let loginCount = Math.min(Math.max(this.$store.state.signupFormData.loginCount || 2, curPlanData.minUsers || 1), curPlanData.maxUsers || 1);
        //     let rate = (curPlanData.userPrice[billFreq] || 0) * loginCount;
        //     return rate;
        // },
        summaryCost: function() {
            let curPlanData = this.curPlanData;
            let billFreq = this.$store.state.signupFormData.billFreq;
            let loginCount = Math.min(Math.max(this.$store.state.signupFormData.loginCount || 2, curPlanData.minUsers || 1), curPlanData.maxUsers || 1);
            let rate = (curPlanData.userPrice[billFreq] || 0) * loginCount;
            // No longer need to multiple by 12 cuz Annual rate in param is full price
            // if (billFreq === "A") {
            //     rate = rate * 12;
            // }
            return rate;
        },
        hasDiscount: function() {
            if (this.signupFormData.couponCode) {
                return true;
            }
            let curPlanData = this.curPlanData;
            let billFreq = this.$store.state.signupFormData.billFreq;
            let df = (curPlanData.discountFactor || {})[billFreq];
            if (df && df !== 1) {
                return true;
            }
            return false;
        },
        discountedCost: function() {
            let billFreq = this.$store.state.signupFormData.billFreq;
            let df = 1;
            if (this.signupFormData.couponCode) {
                const coupon = config.coupons[this.signupFormData.couponCode];
                df = (coupon.discountFactor || {})[billFreq] || 1;
            } else {
                let curPlanData = this.curPlanData;
                df = (curPlanData.discountFactor || {})[billFreq] || 1;
            }
            return this.summaryCost * df;
        },
        isFormSubmitted: function() {
            return (this.$store.state.signupFormData.submitCount | 0) > 0;
        },
        viewPage: function() {
            return this.$store.state.signupFormData.viewPage;
        },
        emailValidationLock: function() {
            return this.$store.getters.emailValidationLock;
        },
        validateProv() {
            // validateProv: extra validation here, others are in Signup-lib
            if (!this.provModel || this.provModel.length === 0) {
                return false;
            }
            return fieldRequiredProblem(this.$store.state.signupFormData.province, null, "You must select a Province/State/Territory");
        },
        cFreqDesc() {
            return this.$store.state.signupFormData.billFreq === "A" ? "Annual" : "Monthly";
        },
        couponsExist() {
            return Object.keys(config.coupons || {}).length > 0;
        }
    }
};
</script>

<style src="./Signup.css" />



// WEBPACK FOOTER //
// src/components/Signup.vue